var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-header", [_vm._v("Your Balance Leave")]),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { "show-header": "false", data: _vm.leaves } },
        [
          _c("el-table-column", { attrs: { property: "name" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { property: "amount" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: "success",
                          size: "medium",
                          effect: "dark"
                        }
                      },
                      [_vm._v(_vm._s(row.amount))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }